import {
  apiV2UetThermalPowerStationGeneratorUnitCreatePost,
  apiV2UetThermalPowerStationGeneratorUnitUpdatePost,
} from '@maxtropy/device-customer-apis-v2';
import { defaultErrorHandling, Form, Input, InputNumber, Modal } from '@maxtropy/components';
import { FC, useEffect, useMemo, useState } from 'react';
import { GeneratorUnitItem, ThermalPowerStationItem } from '../types';

interface Props {
  open: boolean;
  station: ThermalPowerStationItem;
  generatorUnit?: GeneratorUnitItem;
  onCancel: () => void;
  onSuccess: () => void;
}

interface GeneratorUnitFormValues {
  name: string;
  installedCapacity: number;
}

const GeneratorSetModal: FC<Props> = ({ open, station, generatorUnit, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const title = useMemo(() => (generatorUnit ? '编辑发电机组' : '新建发电机组'), [generatorUnit]);

  useEffect(() => {
    if (open && generatorUnit) {
      form.setFieldsValue({ name: generatorUnit.name, installedCapacity: generatorUnit.installedCapacity });
    }
  }, [form, generatorUnit, open]);

  const handleOk = async () => {
    const values: GeneratorUnitFormValues = await form.validateFields();
    setConfirmLoading(true);

    try {
      await (generatorUnit
        ? apiV2UetThermalPowerStationGeneratorUnitUpdatePost({ id: generatorUnit.id, ...values })
        : apiV2UetThermalPowerStationGeneratorUnitCreatePost({ thermalPowerStationId: station.id, ...values })
      ).onError(error => {
        defaultErrorHandling(error);
        throw error;
      });
    } catch {
      return;
    } finally {
      setConfirmLoading(false);
    }

    form.resetFields();
    onSuccess();
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={title}
      open={open}
      destroyOnClose
      contentClassName="modal-form-content"
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      onOk={handleOk}
    >
      <Form form={form}>
        <Form.Item
          label="发电机组名称"
          name="name"
          rules={[
            { required: true, whitespace: true, message: '请输入发电机组名称' },
            { max: 50, message: '最多输入50个字符' },
          ]}
        >
          <Input allowClear placeholder="请输入" />
        </Form.Item>
        <Form.Item label="装机容量" name="installedCapacity" rules={[{ required: true, message: '请输入装机容量' }]}>
          <InputNumber
            min={0}
            max={99999999.99}
            precision={2}
            addonAfter="MW"
            placeholder="请输入"
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GeneratorSetModal;
